<template>
  <div class="auth-container">
    <div class="auth-card-wrapper">
      <themed-card>
        <div class="auth-form">
          <!-- Logo -->
          <div class="auth-logo">
            <img :src="logoUrl" alt="REoptimizer Logo">
          </div>

          <!-- Errors -->
          <div v-if="errors.length > 0" class="auth-alert auth-alert--error">
            <theme-icon icon="alert-circle" type="icons" class="auth-alert__icon" />
            <div class="auth-alert__content">
              <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
            </div>
          </div>

          <!-- Form -->
          <themed-form
            :fields="formFields"
            :model-value="formData"
            layout="vertical"
            @input="handleInput"
            @submit="handleSubmit"
          >
            <template #before-fields>
              <input type="hidden" name="_token" :value="csrfToken">
              <input type="hidden" name="token" :value="token">
            </template>

            <template #submit>
              <div class="auth-actions">
                <themed-button type="submit" variant="default">
                  Reset Password
                </themed-button>
                <a :href="loginRoute" class="auth-actions__link">
                  Back to Login
                </a>
              </div>
            </template>
          </themed-form>
        </div>
      </themed-card>

      <!-- Copyright -->
      <p class="auth-copyright">
        &copy;{{ currentYear }} REoptimizer&reg;, LLC. All rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordForm',
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    oldEmail: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      required: true
    },
    resetRoute: {
      type: String,
      required: true
    },
    loginRoute: {
      type: String,
      required: true
    },
    csrfToken: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formData: {
        email: this.oldEmail,
        password: '',
        password_confirmation: ''
      }
    };
  },
  computed: {
    formFields() {
      return [
        {
          name: 'email',
          type: 'input',
          inputType: 'email',
          label: 'Email',
          required: true
        },
        {
          name: 'password',
          type: 'input',
          inputType: 'password',
          label: 'New Password',
          required: true
        },
        {
          name: 'password_confirmation',
          type: 'input',
          inputType: 'password',
          label: 'Confirm Password',
          required: true
        }
      ];
    },
    currentYear() {
      return new Date().getFullYear();
    },
    logoUrl() {
      return '/img/logos/reoptimizer.webp';
    }
  },
  methods: {
    handleInput(data) {
      this.formData = data;
    },
    async handleSubmit() {
      // Create a form and submit it
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = this.resetRoute;
      
      // Add CSRF token
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = '_token';
      csrfInput.value = this.csrfToken;
      form.appendChild(csrfInput);
      
      // Add reset token
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'token';
      tokenInput.value = this.token;
      form.appendChild(tokenInput);
      
      // Add form data
      Object.keys(this.formData).forEach(key => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = this.formData[key];
        form.appendChild(input);
      });
      
      document.body.appendChild(form);
      form.submit();
    }
  }
}
</script>
